var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgRounded1Shadow = function SvgRounded1Shadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 200",
    filter: "url(#rounded-1-shadow_svg__a)",
    enableBackground: "new 0 0 1600 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "rounded-1-shadow_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "rounded-1-shadow_svg__st1",
    d: "M1491.2 20.7c48.1-3.8 90.6 32.5 94.4 80.6l8.5 107.7h8.8l-9.3-117.7c-3.8-48.1-46.3-84.4-94.4-80.6L-8 131.2v9.4L1491.2 20.7z"
  })));
};
export default SvgRounded1Shadow;